import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // React Query defaults to 3 retries. We explicitly lower it to 2 to fail faster
      // on persistent errors while still providing a window for passive recovery.
      retry: 2,
      // The following restate v5 library defaults explicitly for documentation purposes,
      // ensuring future readers know the dashboard relies on focus and reconnect events.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});
